<template>
    <van-row class="timePop_container" @click="showTimePopup">
        <van-col span="22">
            {{ date ? `${date} 00:00AM - ${date} 12.59PM`
                : `${formatDate(defaultDate)} 00:00 - ${formatDate(defaultDate)} 23:59` }}
        </van-col>
        <van-col span="2">
            <div class="dropDown"> <img src="@/assets/agent/sanjiao_bai.png" alt=""></div>
        </van-col>
    </van-row>
    <div class="calender_popup">
        <van-calendar v-model:show="show" :title="'Seleção de data'" :show-subtitle="false" :max-date="maxDate"
            :min-date="minDate" :show-mark="false" :show-confirm="false" :default-date="defaultDate"
            @confirm="onConfirm">
            <template #bottom-info>
                <div class="custom-day">
                    <!-- <div class="time-label">00:00</div> -->
                </div>
            </template>
        </van-calendar>
    </div>

</template>

<script setup lang="ts">
import { ref, defineEmits } from 'vue';
const show = ref(false)

const today = new Date();
const minDate = new Date();
minDate.setDate(today.getDate() - 30);

const maxDate = new Date();
const defaultDate = new Date();
const date = ref('');
const emits = defineEmits(['getSelectedDateData', 'resetFeild'])
const showTimePopup = () => {
    show.value = true
    emits('resetFeild')
}
const formatDate = (date: Date) =>
    `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

const onConfirm = (value: Date) => {
    show.value = false;
    date.value = formatDate(value);
    emits('getSelectedDateData', date.value)
};
</script>

<style scoped>
.timePop_container {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.25);
    padding: 5px 10px;
    color: #FFFFFF;
    font-weight: 700;
    font-size: 15px;
    display: flex;
    align-items: center;
    margin: 10px 0;
    border: 1px solid rgba(255, 255, 255, 0.25);
}

.dropDown img {
    width: 15px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 30px;
    padding: 5px;
}

.calender_popup {
    color: #000;
}

.calender_popup>>>.van-calendar__popup {
    padding-bottom: 70px;
}

.calender_popup>>>.van-overlay {
    background-color: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(8px);
}

.calender_popup>>>.van-calendar__day {
    color: #000 !important;
}

.calender_popup>>>.van-calendar__day--disabled {
    color: #c8c9cc !important;
}

.calender_popup>>>.van-calendar__weekday {
    color: #000;
}

.custom-day {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
}

.custom-day .time-label {
    font-size: 10px;
    margin-top: 2px;
}
</style>